export const ADDPRODUCT = "products/addproduct";
export const INCREASEPRODUCTQUANTITY = "products/increase_product_qty";
export const DECREASEPRODUCTQUANTITY = "products/decrease_product_qty";
